export enum CATEGORY_ID {
  LARGE = 'largeCategoryId',
  MIDDLE = 'middleCategoryId',
  SMALL = 'smallCategoryId',
  TINY = 'tinyCategoryId'
}

export const LARGE_CATEGORY_QUERY_PARAM = 'large_category';
export const MIDDLE_CATEGORY_QUERY_PARAM = 'middle_category';
export const SMALL_CATEGORY_QUERY_PARAM = 'small_category';
export enum CATEGORY_TYPE {
  LARGE = 'large',
  MIDDLE = 'middle',
  SMALL = 'small',
  TINY = 'tiny'
}

export enum LargeCategorySlug {
  DRUG = 'drug',
  ALCOHOL = 'alcohol'
}

export enum SMALL_CATEGORY_SLUG {
  SKINCARE = 'skincare',
  SUNSCREEN = 'sunscreen',
  LIP_CARE = 'lip_care',
  FACE_PRIMER = 'face_primer',
  FOUNDATION = 'foundation',
  EMULSION = 'emulsion',
  ESSENCE = 'essence',
  EYES = 'eyes',
  CLEANSER = 'cleanser',
  FACE_WASH = 'facewash',
  FACE_LOTION = 'face_lotion',
  EYE_CREAM = 'eye_cream',
  MASK_PACK = 'mask_pack',
  MASK = 'mask',
  TONER = 'toner',
  SERUM = 'serum',
  CREAM = 'cream',
  POWDER = 'powder',
  EYEBROWS = 'eyebrows',
  CHEEK = 'cheek',
  BEAUTY_SUPPLEMENTS = 'beauty_supplements',
  DIET_SUPPLEMENTS = 'diet_supplements',
  HEALTH_SUPPLEMENTS = 'health_supplements',
  HIGH_LIGHTER = 'highlighter',
  BREAST_MILK = 'breast_milk'
}
